import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';
import { toast } from 'sonner';

const PROVIDERS = [
  { key: 'yandex', label: 'Yandex', color: '#FC3F1D' },
  { key: 'mailru', label: 'Mail.ru', color: '#005FF9' },
];

export function SocialLoginButtons() {
  const { t } = useTranslation();
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get('/auth/oauth-config').then((r) => setCfg(r.data || {})).catch(() => setCfg({}));
  }, []);

  if (!cfg) return null;
  const enabled = PROVIDERS.filter((p) => cfg[p.key]);
  if (!enabled.length) return null;

  const start = async (key) => {
    try {
      const { data } = await api.get(`/auth/social/${key}/start`);
      window.location.href = data.authorization_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || t('common.error'));
    }
  };

  return (
    <div className="grid grid-cols-1 gap-2 mt-2" data-testid="social-login-buttons">
      {enabled.map((p) => (
        <Button
          key={p.key}
          type="button"
          variant="outline"
          className="w-full h-11 gap-2"
          style={{ borderColor: p.color, color: p.color }}
          onClick={() => start(p.key)}
          data-testid={`social-login-${p.key}`}
        >
          {t('auth.continue_with', { provider: p.label })}
        </Button>
      ))}
    </div>
  );
}
